import state from "./state";

export default {
  initialLoad: (state) => state.initialLoad,
  tukaReady: (state) => state.tukaReady,
  currentTime: (state) => state.time,
  portletId: (state) => state.portletId,
  containerId: (state) => state.containerId,
  scrollingReserved: (state) => state.scrollingReserved,
  /**
   * 
   * @param {*} state 
   * @returns filtered data
   */
  dataContent: (state) => {
    if (state.targetId != "initial") {
      return state.dataContent.rakenteet.items[state.targetId];
    } else {
      return state.initial;
    }
  },
  getheadersWithoutOrderNum: () =>{
    return state.headersWithoutOrderNum;
  },
  sidebarContent: () => {
    return state.dataContent.sidebar;
  },
  mainContent: () => {
    return state.mainContent;
  },
  searchResults: () => {
    return state.searchResults;
  },
  themeWords: () => {
    return state.dataContent.themeWords;
  },
  mainContentHasItemsWithActiveThemeWords: () => {
    return state.dataContent.mainContentHasItemsWithActiveThemeWords;
  },
  rootItem: () => {
    return state.dataContent.rootItem;
  },
  hash: () => {
    return state.dataContent.hash;
  },
  visibleContentId: () => {
    return state.dataContent.visibleContentId;
  },
  getFilters: () => {
    return state.dataContent.filters;
  },
  getSettings: () => {
    return state.dataContent.settings;
  },
  currentItemLocationData: () => {
    return state.dataContent.currentItemLocationData;
  },
  getTextSearchValue: () => {
    return state.textSearchValue;
  },
  getTextSearchStaticValue: () => {
    return state.textSearchStaticValue;
  },
  getWarnings: () => {
    return state.warnings;
  },
  hasThemeWords: () => {
    return Object.keys(state.dataContent.themeWords).length;
  }
  //print cards
  // cards: (state) => {
  //   return state.dataContent;
  // },
};
